import { render, staticRenderFns } from "./QuizApp.vue?vue&type=template&id=6172f946&"
import script from "./QuizApp.vue?vue&type=script&lang=js&"
export * from "./QuizApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports